<template>
    <div class="table-row-cells">
        <slot></slot>

        <div v-indicator="matrix.days_since_page_viewed" class="table-td">
            <span v-if="!data.days_since_page_viewed" class="indicator-item">
                {{ data.days_since_page_viewed === 0 ? __('Today') : '- ' + __('d') }}
            </span>
            <span v-else class="indicator-item">{{ __choice('{1} :days d|[2,*] :days d', data.days_since_page_viewed, {'days': data.days_since_page_viewed}) }}</span>
        </div>

        <!--<div
            v-indicator:[matrix.compliance_in_percentage]="data.compliance_in_percentage"
            class="table-td cell-adherence"
        >
            <span v-if="data.compliance_in_percentage" class="indicator-item">{{ data.compliance_in_percentage }} %</span>
            <span v-else class="indicator-item"> - </span>
        </div>-->

        <div
            v-indicator="matrix.average_mood.color"
            class="table-td"
        >
            <MatrixMoodEmoji :average-mood="matrix.average_mood ? matrix.average_mood.mood : null" />
        </div>

        <div v-indicator="matrix.last_weight" class="table-td cell-weight">
            <span class="indicator-item" :class="{ 'no-arrow': data.last_weight }">
                {{ data.last_weight ? numberFormat(data.last_weight) : '-' }} kg
            </span>

            <sup
                v-if="matrix.weight_total_progress"
                v-indicator="matrix.weight_total_progress"
                class="data-total"
            >
                {{ numberFormat(data.weight_total_progress) }}
            </sup>
        </div>

        <div v-indicator="matrix.lessons_done" class="table-td">
            <span class="indicator-item">
                <SvgIcon v-if="data.lessons_done" icon="icon-check-circle-big" />
                <SvgIcon v-else icon="icon-times-circle-big" />
            </span>
        </div>

        <div
            v-indicator="matrix.steps_average_percentage"
            class="table-td cell-steps"
        >
            <span v-if="matrix.steps_average_percentage" class="indicator-item">{{ numberFormat(data.steps_average) }}</span>
            <span v-else class="indicator-item">-</span>
        </div>

        <div v-indicator="$_.isNull(matrix.weekly_eaten_meals_percentage) ? 'white' : matrix.weekly_eaten_meals_percentage" class="table-td">
            <span class="indicator-item">{{ $_.isNull(data.weekly_eaten_meals_percentage) ? ' - ' : `${data.weekly_eaten_meals_percentage} %` }}</span>

            <sup v-if="data.self_evaluation_value" v-indicator="data.self_evaluation_color" class="data-total">
                {{ round(data.self_evaluation_value) }}
            </sup>
        </div>

        <div v-indicator="matrix.last_waist" class="table-td cell-weight">
            <span class="indicator-item" :class="{ 'no-arrow': !data.last_waist }">{{ data.last_waist || '-' }} cm</span>

            <sup
                v-if="matrix.waist_total_progress"
                v-indicator="matrix.waist_total_progress"
                class="data-total"
            >
                {{ numberFormat(data.waist_total_progress) }}
            </sup>
        </div>

        <div v-indicator="matrix.habits_successfully_completed" class="table-td">
            <span class="indicator-item">
                {{ $_.isNull(data.habits_successfully_completed) ? ' - ' : data.habits_successfully_completed }}
            </span>
        </div>

        <div
            class="table-td cell-call call-today"
        >
            <span class="indicator-item">
                <consultation-call-status :call_list="matrix.call_status"></consultation-call-status>
            </span>
        </div>
    </div>
</template>

<script>
import MatrixMoodEmoji from '@components/PatientsMatrix/Cells/MatrixMoodEmoji'
import PatientRowCells from '@components/PatientsMatrix/PatientRowCells'

export default {
    components: {
        MatrixMoodEmoji
    },
    extends: PatientRowCells
}
</script>
